import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService, AUTH_KEY } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const auth = localStorage.getItem(AUTH_KEY);
    if (auth) {
      const authHeader = `Basic ${auth}`;
      request = request.clone({
        headers: request.headers.set('Authorization', authHeader)
      });
    }
    return next.handle(request);
  }
} 